module.exports = "pegasus_template/assets/blocks/column-12-theme6.png";